import { useLazyLoadQuery, graphql } from 'react-relay';
import { useParams } from 'react-router-dom';

import type {
  fileUploadQuery as Query,
  fileUploadQuery$data as Response,
} from './__generated__/fileUploadQuery.graphql';

const query = graphql`
  query fileUploadQuery($id: ID!) {
    user__FileUploads__getFileUpload(id: $id) {
      id
      url
    }
  }
`;

export const useFileUpload = (): Response['user__FileUploads__getFileUpload'] => {
  const { id } = useParams<{ id: string }>();
  const { user__FileUploads__getFileUpload: resp } = useLazyLoadQuery<Query>(
    query,
    { id },
    { fetchPolicy: 'store-or-network', fetchKey: id }
  );
  return resp;
};
